
export const FILES_TYPES_THUMBNAILS: string[] = [
'image/jpeg',
'image/png',
'application/pdf',

];
